// extracted by mini-css-extract-plugin
export var cartContainer = "_j5-4";
export var gray = "_j5-1";
export var itemContainer = "_j5-2";
export var itemDetails = "_j5-3";
export var strong = "_j5-0";